"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = exports.DEFAULT_STACK_DIRECTION = exports.DEFAULT_STACK_SPACING = void 0;
var react_1 = __importStar(require("react"));
var Box_1 = require("../Box");
exports.DEFAULT_STACK_SPACING = "-1px";
exports.DEFAULT_STACK_DIRECTION = "vertical";
exports.Stack = react_1.default.forwardRef(function (_a, forwardedRef) {
    var _b;
    var _c = _a.direction, direction = _c === void 0 ? exports.DEFAULT_STACK_DIRECTION : _c, spacing = _a.spacing, children = _a.children, rest = __rest(_a, ["direction", "spacing", "children"]);
    var nodes = react_1.default.Children.toArray(children).filter(react_1.isValidElement);
    var directions = (_b = []).concat.apply(_b, [direction]);
    var spacingProps = {
        mb: directions.map(function (d) { return [d === "vertical" ? spacing : 0]; }),
        mr: directions.map(function (d) { return [d === "horizontal" ? spacing : 0]; }),
    };
    var flexDirection = directions.map(function (d) { return ({ horizontal: "row", vertical: "column" }[d]); });
    return (react_1.default.createElement(Box_1.Box, __assign({ ref: forwardedRef, display: "flex", justifyContent: "flex-start", 
        // TODO
        // @ts-ignore
        flexDirection: flexDirection }, rest), nodes.map(function (child, i) {
        return (0, react_1.cloneElement)(child, __assign({}, (i === nodes.length - 1 ? {} : spacingProps)));
    })));
});
exports.Stack.defaultProps = {
    spacing: exports.DEFAULT_STACK_SPACING,
    direction: exports.DEFAULT_STACK_DIRECTION,
};
exports.Stack.displayName = "Stack";
//# sourceMappingURL=Stack.js.map